<template>
  <div>
    <v-row>
      <v-col :cols="isMobile ? 12 : 6">
        <div>
          <v-row class="mx-4 mt-4">
            <v-col :cols="isMobile ? 12 : 6">
              <SelectionsPane
                @client-selected="getSelectedClient"
                @item-selected="addItemToSelection"
                @date-selected="getSelectedDate"
                @get-discount-amount="getDiscountAmount"
                @get-comment="getComment"
              ></SelectionsPane>

              <div class="mt-4" v-if="!isMobile">
                <v-btn
                  x-large
                  dark
                  block
                  color="#1B5E20"
                  v-if="selectedClient"
                  @click="saveInvoiceData()"
                  ><v-icon>mdi-upload</v-icon> Save {{ docType }} To
                  Database<v-icon>mdi-database</v-icon>
                </v-btn>

                <v-btn
                  class="mt-4"
                  x-large
                  dark
                  block
                  color="red darken-4"
                  v-if="selectedClient"
                  @click="DownloadInvoicePdf()"
                  ><v-icon>mdi-download</v-icon>Download {{ docType }} As PDF
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col :cols="isMobile ? 12 : 6">
              <SelectedItem
                :class="isMobile ? '' : 'pb-4 mt-n4'"
                v-if="selectedInvoice.items.length > 0"
                :items="selectedInvoice.items"
                @update-line-total="updateLineTotal"
                @remove-item="removeItem"
              ></SelectedItem>
              <v-alert
                v-if="isMobile && selectedClient && selectedInvoice"
                :class="isMobile ? ' mb-2' : 'mt-4 mb-2'"
                dismissible
                color="cyan"
                border="left"
                elevation="2"
                colored-border
                icon="mdi-check"
              >
                <p class="mb-n3">{{ selectedClient.name }}</p>
                <small>[{{ selectedClient.institution }}]</small><br />
                <strong
                  >Total {{ docType }}
                  {{
                    getCurrency +
                    formatMoney(selectedInvoice.totalInvoiceAmount)
                  }}</strong
                >
              </v-alert>

              <div :class="isMobile ? 'mt-4' : 'mt-n4'" v-if="isMobile">
                <v-btn
                  x-large
                  dark
                  block
                  color="#1B5E20"
                  v-if="selectedClient"
                  @click="saveInvoiceData()"
                  ><v-icon>mdi-upload</v-icon> Save {{ docType }} To
                  Database<v-icon>mdi-database</v-icon>
                </v-btn>

                <v-btn
                  class="mt-4"
                  x-large
                  dark
                  block
                  color="red darken-4"
                  v-if="selectedClient"
                  @click="DownloadInvoicePdf()"
                  ><v-icon>mdi-download</v-icon>Download {{ docType }} As PDF
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="!isMobile" :cols="isMobile ? 12 : 6">
        <iframe
          :src="pdf"
          width="100%"
          height="1200"
          type="application/pdf"
        ></iframe>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import pdfMakeParts from "@/plugins/pdfMakeParts";
import SelectionsPane from "./SelectionsPane.vue";
import SelectedItem from "./SelectedItem.vue";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "Invoice",
  props: ["selectedInvoiceProp", "docType"],
  components: {
    SelectionsPane,
    SelectedItem,
  },
  watch: {
    async docType(newDocType) {
      await this.initialiseInvoice(null, newDocType);
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  async mounted() {
    if (this.selectedInvoiceProp) {
      await this.initialiseInvoice(this.selectedInvoiceProp, this.docType);
    } else if (this.$route.params.selectedInvoice) {
      await this.initialiseInvoice(
        this.$route.params.selectedInvoice,
        this.$route.params.docType
      );
    } else {
      await this.initialiseInvoice(null, this.docType);
    }

    await this.generatePDF(this, pdfMakeParts.getPdfStyles());
  },
  data() {
    return {
      pdf: null,
      dialogTitle: null,
      invoiceDate: new Date().toISOString().substring(0, 10),
      selectedClient: null,
      stamp64: null,
      selectedInvoice: {
        invoiceNumber: null,
        items: [],
        totalServices: 0,
        subTotal: 0,
        taxPercent: 0,
        totalTax: 0,
        totalProducts: 0,
        totalTransports: 0,
        totalInvoiceAmount: 0,
        discount: 0,
        description: "",
        taxID: 0,
      },
    };
  },
  methods: {
    async initialiseInvoice(invoice, docType) {
      this.$store.commit("setLoader", true);
      let invoiceData = null;
      if (invoice && invoice.invoice_number) {
        invoiceData = await invoicesAndQuotesJs.getInvoiceData(
          invoice.invoice_number,
          docType
        );
        await this.setInvoiceData(invoiceData);
      } else {
        invoiceData = await invoicesAndQuotesJs.getInvoiceData(null, docType);
        await this.setInvoiceData(invoiceData);
      }
      this.$store.commit("setLoader", false);
    },
    async setInvoiceData(invoiceData) {
      if (invoiceData.invoice && invoiceData.invoice.client) {
        const invoice = invoiceData.invoice;
        this.selectedInvoice.invoiceNumber = invoice.invoice_number;
        this.invoiceDate = invoice.invoice_date;
        this.selectedClient = invoice.client;
        this.selectedInvoice.items = invoice.items;
        this.selectedInvoice.description = invoice.description;
        this.selectedInvoice.discount = invoice.calculation.discount;
      } else {
        this.selectedInvoice.invoiceNumber = invoiceData.invoice_number;
      }
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    async getSelectedClient(client) {
      this.selectedClient = client;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getSelectedDate(selectedDate) {
      this.invoiceDate = selectedDate;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getDiscountAmount(discountAmount) {
      this.selectedInvoice["discount"] = Number(discountAmount);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getComment(comment) {
      this.selectedInvoice.description = comment;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async addItemToSelection(item) {
      item.lineTotal = Number(item.price);
      item.quantity = 1;
      this.selectedInvoice.items.push(item);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async updateLineTotal(item) {
      item.lineTotal = (Number(item.price) * Number(item.quantity)).toFixed(2);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async removeItem(arr) {
      const items = arr[0];
      const ind = arr[1];
      items.splice(ind, 1);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    reCalculateTotals() {
      this.selectedInvoice = invoicesAndQuotesJs.reCalculateTotals(
        this.selectedInvoice,
        this.getUserCompany.tax_rate
      );
    },
    async generatePDF(vue, style) {
      const docDefinition = {
        content: await this.getContent(),
        styles: style,
      };

      const doc = pdfMake.createPdf(docDefinition);
      doc.getDataUrl((dataUrl) => {
        this.pdf = dataUrl;
      });
    },
    async DownloadInvoicePdf() {
      const docDefinition = {
        content: await this.getContent(),
        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#2196F3",
          },
          subHeader: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 20],
            color: "#2196F3",
          },
          addressSection: {
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#000",
          },
          fillColumns: {
            margin: [0, 10, 0, 20],
          },
          tableStyle: {
            margin: [0, 10, 0, 20],
          },
          email: {
            fontSize: 12,
            color: "#2196F3",
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 20],
          },
        },
      };

      pdfMake
        .createPdf(docDefinition)
        .download(
          this.getUserCompany.name +
            " " +
            this.docType +
            " " +
            this.selectedInvoice.invoiceNumber
        );
    },
    async getContent() {
      return await pdfMakeParts.getContent(
        this.getUserCompany,
        this.docType.toUpperCase(),
        this.selectedInvoice,
        this.selectedClient,
        this.invoiceDate
      );
    },
    async saveInvoiceData() {
      this.$store.commit("setLoader", true);

      const response = await invoicesAndQuotesJs.saveInvoiceData(
        this.docType,
        this.selectedClient,
        this.selectedInvoice,
        this.invoiceDate
      );

      this.$store.commit("setLoader", false);
      this.$toast.success("Invoice Data Successfully Saved", {
        duration: 3000,
      });
    },
  },
};
</script>

<style></style>
